// extracted by mini-css-extract-plugin
export default {"diff-file-header":"DiffFileHeader-module__diff-file-header--TjXyn","collapsed":"DiffFileHeader-module__collapsed--FPwYM","file-name":"DiffFileHeader-module__file-name--mY1O5"};